const BASE_URL = process.env.REACT_APP_API_URL || '/api';
const getToken = () => localStorage.getItem('txtmycar_token');
const headers = (extra = {}) => ({
  'Content-Type': 'application/json',
  ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
  ...extra,
});
const handleResponse = async (res) => {
  const data = await res.json();
  if (!res.ok) {
    const message = data.errors?.[0]?.msg || data.error || 'Something went wrong';
    throw new Error(message);
  }
  return data;
};
export const api = {
  auth: {
    signup: (body) =>
      fetch(`${BASE_URL}/auth/signup`, { method: 'POST', headers: headers(), body: JSON.stringify(body) }).then(handleResponse),
    login: (body) =>
      fetch(`${BASE_URL}/auth/login`, { method: 'POST', headers: headers(), body: JSON.stringify(body) }).then(handleResponse),
    me: () =>
      fetch(`${BASE_URL}/auth/me`, { headers: headers() }).then(handleResponse),
    verify: (token) =>
      fetch(`${BASE_URL}/auth/verify/${token}`).then(handleResponse),
    resendVerification: (email) =>
      fetch(`${BASE_URL}/auth/resend-verification`, { method: 'POST', headers: headers(), body: JSON.stringify({ email }) }).then(handleResponse),
    referral: () =>
      fetch(`${BASE_URL}/auth/referral`, { headers: headers() }).then(handleResponse),
    forgotPassword: (email) =>
      fetch(`${BASE_URL}/auth/forgot-password`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email }) }).then(handleResponse),
    resetPassword: (token, password) =>
      fetch(`${BASE_URL}/auth/reset-password`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token, password }) }).then(handleResponse),
  },
  vehicles: {
    list: () =>
      fetch(`${BASE_URL}/vehicles`, { headers: headers() }).then(handleResponse),
    register: (body) =>
      fetch(`${BASE_URL}/vehicles`, { method: 'POST', headers: headers(), body: JSON.stringify(body) }).then(handleResponse),
    remove: (id) =>
      fetch(`${BASE_URL}/vehicles/${id}`, { method: 'DELETE', headers: headers() }).then(handleResponse),
  },
  messages: {
    send: (body) =>
      fetch(`${BASE_URL}/messages/send`, { method: 'POST', headers: headers(), body: JSON.stringify(body) }).then(handleResponse),
    history: () =>
      fetch(`${BASE_URL}/messages/history`, { headers: headers() }).then(handleResponse),
  },
  payments: {
    createCheckout: () =>
      fetch(`${BASE_URL}/payments/create-checkout`, { method: 'POST', headers: headers() }).then(handleResponse),
    credits: () =>
      fetch(`${BASE_URL}/payments/credits`, { headers: headers() }).then(handleResponse),
    history: () =>
      fetch(`${BASE_URL}/payments/history`, { headers: headers() }).then(handleResponse),
  },
};
